import { IApplicationState } from '../../types/redux';
import { hasFutureObjects } from '../../utils/map';
import { selectRegularInfrastructure } from '../infrastructure';
import { getIsTransportAccessibilityServiceAvailable } from './getIsTransportAccessibilityServiceAvailable';

/**
 * Видима ли панель сервисов на карте в правом верхнем углу.
 */
export function getIsMapServicesVisible(state: IApplicationState) {
  const mapServicesEnabled = state.common.mapOptions?.servicesEnabled || false;

  if (!mapServicesEnabled) {
    return false;
  }

  const isTransportAccessibilityServiceAvailable = getIsTransportAccessibilityServiceAvailable(state);
  const regularInfrastructure = selectRegularInfrastructure(state);

  return isTransportAccessibilityServiceAvailable || hasFutureObjects(regularInfrastructure);
}
